import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function MessagingIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props} viewBox="0 0 26 25" fill="none">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3816 18.75H12.0941L5.64414 23.25V18.75H2.41914C1.52858 18.75 0.806641 18.0784 0.806641 17.25V2.25C0.806641 1.42157 1.52858 0.75 2.41914 0.75H23.3816C24.2722 0.75 24.9941 1.42157 24.9941 2.25V17.25C24.9941 18.0784 24.2722 18.75 23.3816 18.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.06328 9.375C7.84064 9.375 7.66016 9.54289 7.66016 9.75C7.66016 9.95711 7.84064 10.125 8.06328 10.125C8.28592 10.125 8.46641 9.95711 8.46641 9.75C8.46641 9.54289 8.28592 9.375 8.06328 9.375"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9012 9.375C12.6785 9.375 12.498 9.54289 12.498 9.75C12.498 9.95711 12.6785 10.125 12.9012 10.125C13.1238 10.125 13.3043 9.95711 13.3043 9.75C13.3043 9.54289 13.1238 9.375 12.9012 9.375"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7371 9.375C17.5145 9.375 17.334 9.54289 17.334 9.75C17.334 9.95711 17.5145 10.125 17.7371 10.125C17.9597 10.125 18.1402 9.95711 18.1402 9.75C18.1402 9.54289 17.9597 9.375 17.7371 9.375"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
